var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 165c0 8.291-6.709 15-15 15H45c-8.291 0-15-6.709-15-15v-30c0-24.814 20.186-45 45-45h30c8.291 0 15 6.709 15 15v60z",
    fill: "#1689fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482 165c0 8.291-6.709 15-15 15h-60c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15h30c24.814 0 45 20.186 45 45v30z",
    fill: "#136ef1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407 90h-75V15c0-8.401-6.599-15-15-15H105c-8.401 0-15 6.599-15 15v150c0 8.399 6.599 15 15 15h302c8.401 0 15-6.601 15-15v-60c0-8.401-6.599-15-15-15z",
    fill: "#cae8f9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407 180H257V0h60c8.401 0 15 6.599 15 15v75h75c8.401 0 15 6.599 15 15v60c0 8.399-6.599 15-15 15z",
    fill: "#b7e0f6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422 120H317c-8.291 0-15-6.709-15-15V0h32.695c11.777 0 23.32 4.775 31.641 13.11l42.568 42.583C417.225 64.043 422 75.557 422 87.305V120z",
    fill: "#cae8f9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M467 150H45c-24.902 0-45 20.099-45 45v152c0 24.899 20.098 45 45 45h422c24.902 0 45-20.101 45-45V195c0-24.901-20.098-45-45-45z",
    fill: "#17ace8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135 240H75c-19.773 0-19.854-30 0-30h60c19.773 0 19.854 30 0 30z",
    fill: "#cae8f9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M512 195v152c0 24.899-20.098 45-45 45H257V150h210c24.902 0 45 20.099 45 45z",
    fill: "#1689fc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90 317v180c0 8.399 6.599 15 15 15h302c8.401 0 15-6.601 15-15V317H90z",
    fill: "#cae8f9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422 317v180c0 8.399-6.599 15-15 15H257V317h165z",
    fill: "#b7e0f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#17ace8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347 392H165c-19.797 0-19.797-30 0-30h182c19.797 0 19.797 30 0 30zM347 452H165c-19.797 0-19.797-30 0-30h182c19.797 0 19.797 30 0 30z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1689fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347 452h-90v-30h90c19.797 0 19.797 30 0 30zM347 392h-90v-30h90c19.797 0 19.797 30 0 30zM437 332H75c-19.797 0-19.797-30 0-30h362c19.797 0 19.797 30 0 30z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M437 332H257v-30h180c19.797 0 19.797 30 0 30z",
    fill: "#136ef1"
  })));
}

export default SvgPrinter;